import { render } from "./ProjectFilesTable.vue?vue&type=template&id=10934755"
import script from "./ProjectFilesTable.vue?vue&type=script&lang=js"
export * from "./ProjectFilesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__